import { type QueryFunctionContext } from '@tanstack/react-query'
import { type CommunicationPreferencesKey } from '@/features/account/services/Preferences/queries'
import { apiGet } from '@/features/shared/utils/dataFetching'
import { communicationPreferences } from '@/features/account/services/Preferences/endpointHelpers'
import { type CommunicationPreferences } from '@/features/account/services/Preferences/types'

export const fetchCommunicationPreferences = (
  context: QueryFunctionContext<CommunicationPreferencesKey>,
) => {
  const params = context.queryKey[1]
  return apiGet<CommunicationPreferences>({
    context,
    config: { url: communicationPreferences(params.user_id ?? 0) },
    fetcherName: 'fetchCommunicationPreferences',
  })
}
